<div class="modal-header">
  <h5 class="modal-title">Edit Broker User</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>

</div>
<div class="card text-black" [ngClass]="{'blur-background' : updating}">
  <i class="fab fa-apple"></i>
  <div class="card-body">
    <div *ngIf = "role == 'admin'">
      <form class="row g-3" [formGroup]="brokerForm" (ngSubmit)="onClickBrokerEdit()" novalidate>

        <div class="col-md-6 text-start">
          <label for="brokerFullName" class="form-label">Full Name</label>
          <input type="text" class="form-control" id="brokerFullName" formControlName="brokerFullName"
                 [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerFullName'].errors }">
          <div *ngIf="submitted && formBrokerControl['brokerFullName'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['brokerFullName'].errors['required']">
              Full Name is required
            </div>
          </div>
        </div>


        <div class="col-md-6 text-start">
          <label for="brokerCompany" class="form-label">Company name</label>
          <input type="text" class="form-control" id="brokerCompany" formControlName="brokerCompany"
                 [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerCompany'].errors }">
          <div *ngIf="submitted && formBrokerControl['brokerCompany'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['brokerCompany'].errors['required']">
              Company name is required
            </div>
          </div>
        </div>

        <div class="col-md-6 text-start">
          <label for="brokerEmail" class="form-label">Email address</label>
          <input type="text" class="form-control" id="brokerEmail" formControlName="brokerEmail"
                 [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerEmail'].errors }" [readonly]="true">
          <div *ngIf="submitted && formBrokerControl['brokerEmail'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['brokerEmail'].errors['required']">
              Email is required
            </div>
            <div *ngIf="formBrokerControl['brokerEmail'].errors['email']">
              Email is not valid
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start">
          <label for="brokerCountryCode" class="form-label">Contact Number</label>
          <div class="d-flex">
            <ngx-intl-tel-input *ngIf="allowedCountryCodes.length > 0" type="text" id="contactNo"
                                formControlName="brokerCountryCode"
                                [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerCountryCode'].errors }"
                                [enablePlaceholder]="true"
                                [searchCountryFlag]="true"
                                [selectFirstCountry]="true"
                                [separateDialCode]="true"
                                [maxLength]="15"
                                [outerText]=""
                                [phoneValidation]="true"
                                [disabled]="true"
                                [enableAutoCountrySelect]="true"
                                [onlyCountries]="allowedCountryCodes"
            ></ngx-intl-tel-input>
            <div class="sl-flex-row" id="contactNum">
              <input type="tel" class="form-control" id="brokerContactNo"
                     formControlName="brokerContactNo"
                     [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerContactNo'].errors }">
              <div *ngIf="submitted && formBrokerControl['brokerContactNo'].errors" class="invalid-feedback">
                <div *ngIf="formBrokerControl['brokerContactNo'].errors['required']">
                  &nbsp;&nbsp;Contact Number is required
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-6 text-start">
          <label for="brokerCountry" class="form-label">Country</label>
          <select class="form-select" aria-label="Default select example" formControlName="brokerCountry" size='1' onfocus='if (this.options.length > 5){this.size = 5}' onblur="this.size = 1" onchange='this.size = 1;  this.blur();'
                  [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerCountry'].errors }" id="countryCode">
            <option *ngFor="let country of countries" value="{{country.countryId}}">{{country.countryName}}</option>
          </select>
          <div *ngIf="submitted && formBrokerControl['brokerCountry'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['brokerCountry'].errors['required']">
              Select a country
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start">
          <label for="brokerUserName" class="form-label">Username</label>
          <input type="text"
                 class="form-control" id="brokerUserName" formControlName="brokerUserName"
                 [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerUserName'].errors }"
                 [readonly]="true">
          <div *ngIf="submitted && formBrokerControl['brokerUserName'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['brokerUserName'].errors['required']">
              Username is required
            </div>
            <div *ngIf="formBrokerControl['brokerUserName'].errors['alreadyExist']">
              Username already exist
            </div>
            <div *ngIf="formBrokerControl['brokerUserName'].errors['invalid']">
              Username is invalid
            </div>
          </div>
        </div>

        <div class="col-md-6 text-start" >
          <label for="region" class="form-label">Region</label>
          <select class="form-select" aria-label="Default select example" formControlName="region"
                  [ngClass]="{ 'is-invalid': submitted && formBrokerControl['region'].errors }">
            <option value="asia">ASIA</option>
            <option value="mena">MENA</option>
            <option value="global sandbox">GLOBAL SANDBOX</option>
          </select>
          <div *ngIf="submitted && formBrokerControl['region'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['region'].errors['required']">
              Select a region
            </div>
          </div>
        </div>

        <div class="col-md-6 text-start" >
          <label for="brokerInstitution" class="form-label">Institution</label>
          <select class="form-select" aria-label="Default select example" formControlName="brokerInstitution" size='1' onfocus='if (this.options.length > 5){this.size = 5}' onblur="this.size = 1" onchange='this.size = 1;  this.blur();'
                  [ngClass]="{ 'is-invalid': submitted && formBrokerControl['brokerInstitution'].errors }">

            <option [hidden]="formBrokerControl['region'].value === 'mena'" [ngValue]="institution.institutionId"
                    *ngFor="let institution of institutions">{{institution.institution}}</option>

            <option [hidden]="formBrokerControl['region'].value === 'asia'" [ngValue]="institution.institutionId"
                    *ngFor="let institution of institutions">{{institution.institution}}</option>

            <option [hidden]="formBrokerControl['region'].value === 'global sandbox'" [ngValue]="institution.institutionId"
                    *ngFor="let institution of institutions">{{institution.institution}}</option>

          </select>
          <div *ngIf="submitted && formBrokerControl['brokerInstitution'].errors" class="invalid-feedback">
            <div *ngIf="formBrokerControl['brokerInstitution'].errors['required']">
              Select a institution
            </div>
          </div>
        </div>

        <div class="col-6 mb-3">
          <h6>Preferred APIs</h6>
          <div class="general-checkBox" >
            <input type="checkbox" id="GtnApiEnableCheck" ng-model="check" formControlName="openAPIEnabled"/>
            GTN Fintech APIs
          </div>
          <div class="general-checkBox" >
            <input type="checkbox" id="EmbedApiEnableCheck" ng-model="check" formControlName="embedAPIEnabled"/>
            GTN Embed APIs
          </div>
          <div class="general-checkBox" >
            <input type="checkbox" id="AccountApiEnableCheck" ng-model="check" formControlName="backOfficeAPIEnabled"/>
            GTN Backoffice APIs
          </div>
          <div class="general-checkBox" >
            <input type="checkbox" id="DwmApiEnableCheck" ng-model="check" formControlName="dwmAPIEnabled"/>
            GTN DWM APIs
          </div>
          <div class="general-checkBox" >
            <input type="checkbox" id="FeedApiEnableCheck" ng-model="check" formControlName="feedAPIEnabled"/>
            GTN Market Data APIs
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">
            Close
          </button>
          <button type="button" class="btn btn-primary" type="submit">
            <div *ngIf="updating" class="spinner-border spinner-border-sm text-light" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p *ngIf="!updating">
              Update
            </p>
          </button>
        </div>
      </form>
    </div>


    <div *ngIf = "role == 'brokerAdmin'">
      <form class="row g-3" [formGroup]="normalBrokerForm" (ngSubmit)="onClickNormalBrokerEdit()" novalidate>

        <div class="col-md-6 text-start">
          <label for="normalBrokerFullName" class="form-label">Full Name</label>
          <input type="text" class="form-control" id="normalBrokerFullName" formControlName="normalBrokerFullName"
                 [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerFullName'].errors }">
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerFullName'].errors" class="invalid-feedback">
            <div *ngIf="formNormalBrokerControl['normalBrokerFullName'].errors['required']">
              Full Name is required
            </div>
          </div>
        </div>





        <div class="col-md-6 text-start">
          <label for="normalBrokerCompany" class="form-label">Company name</label>
          <input type="text" class="form-control" id="normalBrokerCompany" formControlName="normalBrokerCompany"
                 [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerCompany'].errors }">
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerCompany'].errors" class="invalid-feedback">
            <div *ngIf="formNormalBrokerControl['normalBrokerCompany'].errors['required']">
              Company name is required
            </div>
          </div>
        </div>


        <div class="col-md-6 text-start">
          <label for="normalBrokerEmail" class="form-label">Email address</label>
          <input type="text" class="form-control" id="normalBrokerEmail" formControlName="normalBrokerEmail"
                 [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerEmail'].errors }">
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerEmail'].errors" class="invalid-feedback">
            <div *ngIf="formNormalBrokerControl['normalBrokerEmail'].errors['required']">
              Email is required
            </div>
            <div *ngIf="formNormalBrokerControl['normalBrokerEmail'].errors['email']">
              Email is not valid
            </div>
          </div>
        </div>

        <div class="col-md-6 text-start">
          <label for="normalBrokerCountryCode" class="form-label">Contact Number</label>
          <div class="d-flex">
            <ngx-intl-tel-input *ngIf="allowedCountryCodes.length > 0" type="text" id="contactNo"
                                formControlName="normalBrokerCountryCode"
                                [ngClass]="{ 'is-invalid': submitted && formBrokerControl['normalBrokerCountryCode'].errors }"
                                [enablePlaceholder]="true"
                                [searchCountryFlag]="true"
                                [selectFirstCountry]="true"
                                [separateDialCode]="true"
                                [maxLength]="15"
                                [outerText]=""
                                [phoneValidation]="true"
                                [disabled]="true"
                                [enableAutoCountrySelect]="true"
            ></ngx-intl-tel-input>
            <div class="sl-flex-row" id="contactNum">
              <input type="tel" class="form-control" id="normalBrokerContactNo"
                     formControlName="normalBrokerContactNo"
                     [ngClass]="{ 'is-invalid': submitted && formBrokerControl['normalBrokerContactNo'].errors }">
              <div *ngIf="submitted && formBrokerControl['normalBrokerContactNo'].errors" class="invalid-feedback">
                <div *ngIf="formBrokerControl['normalBrokerContactNo'].errors['required']">
                  &nbsp;&nbsp;Contact Number is required
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-6 text-start">
          <label for="normalBrokerCountry" class="form-label">Country</label>
          <select class="form-select" aria-label="Default select example" formControlName="normalBrokerCountry" size='1' onfocus='if (this.options.length > 5){this.size = 5}' onblur="this.size = 1" onchange='this.size = 1;  this.blur();'
                  [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerCountry'].errors }" id="normalBrokerCountry">
            <option *ngFor="let country of countries" value="{{country.countryId}}">{{country.countryName}}</option>
          </select>
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerCountry'].errors" class="invalid-feedback">
            <div *ngIf="formNormalBrokerControl['normalBrokerCountry'].errors['required']">
              Select a country
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start">
          <label for="normalBrokerUserName" class="form-label">Username</label>
          <input type="text"
                 class="form-control" id="normalBrokerUserName" formControlName="normalBrokerUserName"
                 [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerUserName'].errors }"
                 [readonly]="true">
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerUserName'].errors" class="invalid-feedback">
            <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['required']">
              Username is required
            </div>
            <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['alreadyExist']">
              Username already exist
            </div>
            <div *ngIf="formNormalBrokerControl['normalBrokerUserName'].errors['invalid']">
              Username is invalid
            </div>
          </div>
        </div>


        <div class="col-md-6 text-start">
          <label for="normalBrokerRegion" class="form-label">Region</label>
          <input type="text" class="form-control" id="normalBrokerRegion" formControlName="normalBrokerRegion"
                 [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerRegion'].errors }" [readonly]="true" >
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerRegion'].errors" class="invalid-feedback">
          </div>
        </div>


        <div class="col-md-6 text-start">
          <label for="normalBrokerInstitution" class="form-label">Institution</label>
          <input type="text" class="form-control" id="normalBrokerInstitution" formControlName="normalBrokerInstitution" size='1' onfocus='if (this.options.length > 5){this.size = 5}' onblur="this.size = 1" onchange='this.size = 1;  this.blur();'
                 [ngClass]="{ 'is-invalid': submitted && formNormalBrokerControl['normalBrokerInstitution'].errors }" [readonly]="true">
          <div *ngIf="submitted && formNormalBrokerControl['normalBrokerInstitution'].errors" class="invalid-feedback">
          </div>
        </div>




        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">
            Close
          </button>
          <button type="button" class="btn btn-primary" type="submit">
            <div *ngIf="updating" class="spinner-border spinner-border-sm text-light" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p *ngIf="!updating">
              Update
            </p>
          </button>
        </div>
      </form>
    </div>

  </div>
</div>
